import type { AuthRepository, SignInCommand } from '../repository/AuthRepository';
import type { AuthSession } from '../entity/AuthTypes';

export class SignInUseCase {
  constructor(private readonly repository: AuthRepository) {}

  async execute(command: SignInCommand): Promise<AuthSession> {
    if (!command.user_email?.trim()) throw new Error('user_email is required');
    if (!command.password) throw new Error('password is required');
    return this.repository.signIn(command);
  }
}

